import React, { useState, useEffect } from 'react'

const ClientsPagination = props => {
  const [totalPages, setTotalPages] = useState(Math.ceil(props.totalCount / props.perPage))

  const range = (start, end) => {
    return Array(end - start).fill().map((_, idx) => start + idx)
  }

  const previousPages = () => {
    if (props.page < 5) {
      return (
        range(1, props.page).map(page => (
          <a
            key={page}
            className='pagination-button'
            onClick={() => props.onPageChange(page)}
          >
            {page}
          </a>
        ))
      )
    } else {
      return (
        <div>
          <a className='pagination-button' onClick={() => props.onPageChange(1)}>1</a>
          <span>...</span>
          <a className='pagination-button' onClick={() => props.onPageChange(props.page - 1)}>{props.page - 1}</a>
        </div>
      )
    }
  }

  const nextPages = () => {
    if (totalPages - props.page >= 5) {
      return (
        <div>
          <a className='pagination-button' onClick={() => props.onPageChange(props.page + 1)}>{props.page + 1}</a>
          <span>...</span>
          <a className='pagination-button' onClick={() => props.onPageChange(totalPages)}>{totalPages}</a>
        </div>
      )
    } else if (totalPages - props.page != 0) {
      if (!totalPages) return

      return (
        range(props.page + 1, totalPages + 1).map(page => (
          <a
            key={page}
            className='pagination-button'
            onClick={() => props.onPageChange(page)}
          >
            {page}
          </a>
        ))
      )
    }
  }

  const paginationInfo = () => {
    const from = props.totalCount < props.perPage ? 1 : (props.perPage * (props.page - 1)) + 1
    const to = props.page == totalPages ? props.totalCount : from + (props.perPage - 1)
    return (
      <div>
        Showing {!totalPages ? 0 : from} to {!totalPages ? 0 : to} of {!totalPages ? 0 : props.totalCount} entries
      </div>
    )
  }

  useEffect(() => {
    const newPagesCount = Math.ceil(props.totalCount / props.perPage)
    if (newPagesCount !== totalPages) {
      setTotalPages(newPagesCount);
    }
  }, [props.totalCount])

  return (
    <div className='client-portal__info'>
      {paginationInfo()}
      <div className='clients-pages'>
        <a
          className='pagination-button'
          onClick={() => {props.page - 1 <= 0 ? null :props.onPageChange(props.page - 1)}}
        >
          previous
        </a>
        {previousPages()}
        <a className='pagination-button current-page'>{props.page}</a>
        {nextPages()}
        <a
          className='pagination-button'
          onClick={() => {totalPages - props.page >= 1 ? props.onPageChange(props.page + 1) : null}}
        >
          next
        </a>
      </div>
    </div>
  )
}

export default ClientsPagination
